module.exports = __webpack_public_path__ + "media/images/icon_originals_basecolor-32bae065868ddc3cfff4564e44c794e1.svg";